<template>
  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{'tracking_codes_download' | translate}}</h3>
      </div>
      <div class="box-body">
        <div class="col-md-6 col-sm-6">
          <div class="input-group">
            <div class="input-group-addon">
              {{'period' | translate}}
            </div>
            <date-range-picker
              :class="['form-control', endRange === '' ? '' : 'focused']"
              :startDate="startRange"
              :endDate="endRange"
              id="ordertime"
              @pepe="onDateRangeChanged"
            >
            </date-range-picker>
            <span class="input-group-btn">
                <button
                  class="btn btn-success"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Download an order list in your specified date range"
                  @click="downloadTrackingCodes()"
                >
                  <i class="fa fa-download mr-5"></i>Download
                </button>
              </span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import DateRangePicker from '../../tools/DateRangePicker.vue'
import jsPDF from 'jspdf'
import 'jspdf-autotable'

export default {
  name: 'TrackingCodesView',
  data () {
    return {
      startRange: moment().subtract(1, 'month'),
      endRange: moment()
    }
  },
  components: {
    dateRangePicker: DateRangePicker
  },
  methods: {
    onDateRangeChanged (picker) {
      this.dateRange = `${picker.startDate} - ${picker.endDate}`
      this.startRange = picker.startDate
      this.endRange = picker.endDate
    },
    downloadTrackingCodes () {
      let start = this.startRange.format('YYYY-MM-DD')
      let end = this.endRange.format('YYYY-MM-DD')

      API.get(`download/trackingCodes?dateFrom=${start}&dateTo=${end}`)
        .then(response => {
          let arrayResponse = JSON.parse(JSON.stringify(response.data))
          const doc = new jsPDF()
          for (let key in arrayResponse) {
            let containerArr = []
            for (var i = 0; i < arrayResponse[key].length; i++) {
              containerArr[i] = [key, arrayResponse[key][i].order_id, arrayResponse[key][i].tracking_number, arrayResponse[key][i].shipping_date]
            }
            doc.autoTable({
              showHead: 'firstPage',
              head: [['Carrier', 'Order ID', 'Tracking Number', 'Shipping Date']],
              body: containerArr
            })
          }
          doc.save(`tracking-codes_${start}-${end}.pdf`)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/Downloads/TrackingCodesView.vue